export default class ModelVersionViewModel {
    id = null;
    assetId = null;
    versionNumber=null;
    versionName=null;
    isCurrent=false;
    associatedScan=null;
    supplementaryScans=[];
    scans=[];
    description=null;
    modelViewPointX=0;
    modelViewPointY=0;
    modelViewPointZ=0;
    modelViewPointRotationX=0;
    modelViewPointRotationY=0;
    modelViewPointRotationZ=0;
    modelPath=null;
    eTag=null;
    // Bake/publish state (server-computed). needsPublish: saved settings differ from the last bake.
    // isBaking: at least one scan is currently queued/processing.
    needsPublish=false;
    isBaking=false;

    constructor(modelVersion){
        this.id = modelVersion.id;
        this.assetId = modelVersion.assetId;
        this.versionNumber = modelVersion.versionNumber;
        this.versionName = modelVersion.versionName;
        this.description = modelVersion.versionDescription;
        this.isCurrent = modelVersion.isCurrent;
        this.associatedScan = modelVersion.associatedScan;
        this.supplementaryScans = modelVersion.supplementaryScans ?? [];
        this.scans = modelVersion.scans ?? [];

        this.modelViewPointX = modelVersion.modelViewPointX;
        this.modelViewPointY = modelVersion.modelViewPointY;
        this.modelViewPointZ = modelVersion.modelViewPointZ;

        this.modelViewPointRotationX = modelVersion.modelViewPointRotationX;
        this.modelViewPointRotationY = modelVersion.modelViewPointRotationY;
        this.modelViewPointRotationZ = modelVersion.modelViewPointRotationZ;

        this.modelPath = modelVersion.modelPath;

        this.eTag = modelVersion.eTag;

        this.needsPublish = modelVersion.needsPublish ?? false;
        this.isBaking = modelVersion.isBaking ?? false;
    }
}